(function () {
  'use strict';

  function isPickupHeading(text) {
    var t = (text || '').trim().toLowerCase();
    return (
      t.indexOf('find in-store') !== -1 ||
      t.indexOf('in-store pickup') !== -1 ||
      t.indexOf('pickup option') !== -1 ||
      t.indexOf(String.fromCharCode(0x0627, 0x0633, 0x062a, 0x0644, 0x0627, 0x0645)) !== -1
    );
  }

  function getProductHandle() {
    var productInfo = document.querySelector('product-info');
    var url = (productInfo && productInfo.dataset.url) || location.pathname || '';
    var handle = url.split('/products/').pop() || '';
    return handle.split('?')[0].split('#')[0];
  }

  function getVariantId() {
    var variantInput = document.querySelector('form[id^="product-form"] input[name="id"]');
    return variantInput && variantInput.value ? parseInt(variantInput.value, 10) : null;
  }

  function getPickupSlot() {
    return document.querySelector('.product__description #inventory-info-app');
  }

  function expandInventoryDetails(slot) {
    slot = slot || getPickupSlot();
    if (!slot) return;

    slot.querySelectorAll('.iia-details-container').forEach(function (el) {
      el.classList.remove('iia-collapsed');
      el.classList.add('iia-display');
      el.style.height = 'auto';
      el.style.maxHeight = 'none';
      el.style.overflow = 'visible';
      el.style.display = 'block';
    });

    var header = slot.querySelector('.iia-header, label.iia-header, .iia-clickable, .iia-header-container');
    if (header && !slot.querySelector('.iia-list-item, .iia-title-text, .iia-location')) {
      try {
        header.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      } catch (e) {
        try {
          header.click();
        } catch (err) {}
      }
    }
  }

  /**
   * Kark app often injects #inventory-info-app before Add to Cart when it
   * misses our description slot. Move that live widget into the accordion.
   */
  function relocateInventoryWidget() {
    var slot = getPickupSlot();
    if (!slot) return false;

    var candidates = document.querySelectorAll('#inventory-info-app, .iia-container');
    var moved = false;

    candidates.forEach(function (el) {
      if (!el || el === slot || slot.contains(el)) return;
      // Skip empty placeholders we created
      if (!el.childNodes.length && el.getAttribute('iia-is-default') !== 'true' && !el.querySelector('*')) {
        if (el.id === 'inventory-info-app') el.removeAttribute('id');
        return;
      }

      // Prefer moving the whole live node into the pickup accordion
      if (el.id === 'inventory-info-app' || el.querySelector('.iia-list, .iia-list-item, .iia-header, .iia-details-container')) {
        var parent = slot.parentNode;
        if (parent) {
          // Replace empty slot with the live widget node (preserves Preact root)
          parent.replaceChild(el, slot);
          el.id = 'inventory-info-app';
          el.classList.add('iia-container', 'product-pickup-inventory');
          el.style.display = '';
          el.hidden = false;
          slot = el;
          moved = true;
        }
      }
    });

    // Deduplicate leftover empty inventory nodes
    document.querySelectorAll('#inventory-info-app').forEach(function (el) {
      if (el !== slot) {
        el.removeAttribute('id');
        if (!el.childNodes.length) el.parentNode && el.parentNode.removeChild(el);
      }
    });

    expandInventoryDetails(slot);
    return moved;
  }

  function callLoadApp() {
    var handle = getProductHandle();
    var variantId = getVariantId();
    if (!window.inventoryInfo || !window.inventoryInfo.api || typeof window.inventoryInfo.api.loadApp !== 'function') {
      return false;
    }
    try {
      window.inventoryInfo.api.loadApp({ handle: handle, variant: variantId });
    } catch (e) {}
    setTimeout(relocateInventoryWidget, 200);
    setTimeout(relocateInventoryWidget, 600);
    setTimeout(relocateInventoryWidget, 1200);
    setTimeout(function () {
      expandInventoryDetails();
    }, 400);
    setTimeout(function () {
      expandInventoryDetails();
    }, 1400);
    return true;
  }

  function loadPickupInventoryWidget() {
    if (callLoadApp()) return;

    if (window.__inventoryLoadTimer) return;
    var attempts = 0;
    window.__inventoryLoadTimer = setInterval(function () {
      attempts += 1;
      if (callLoadApp()) {
        clearInterval(window.__inventoryLoadTimer);
        window.__inventoryLoadTimer = null;
      } else if (attempts >= 40) {
        clearInterval(window.__inventoryLoadTimer);
        window.__inventoryLoadTimer = null;
        relocateInventoryWidget();
      }
    }, 250);
  }

  function injectScript(src, onload) {
    if (!src || src === 'about:blank') return null;
    if (document.querySelector('script[src="' + src + '"]')) {
      if (onload) onload();
      return null;
    }
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.dataset.coachKeep = '1';
    if (onload) s.onload = onload;
    document.body.appendChild(s);
    return s;
  }

  function loadInventoryScriptOnce() {
    if (window.__locationInventoryRequested) {
      loadPickupInventoryWidget();
      relocateInventoryWidget();
      return;
    }
    window.__locationInventoryRequested = true;

    // Un-gate any queued locationinventory scripts
    window.__tpAllowHeavy = true;
    if (window.__tpScriptQueue && window.__tpScriptQueue.length) {
      window.__tpScriptQueue.slice().forEach(function (el) {
        var src = el.getAttribute && el.getAttribute('data-src');
        if (!src || src === 'about:blank') return;
        if (src.indexOf('locationinventory') === -1 && src.indexOf('inventory-info') === -1) return;
        injectScript(src, loadPickupInventoryWidget);
      });
    }

    document
      .querySelectorAll(
        'script[type="text/tp-deferred"][data-src*="locationinventory"], script[type="text/lazyloadscript"][data-delayed-src*="locationinventory"]'
      )
      .forEach(function (old) {
        var src = old.getAttribute('data-src') || old.getAttribute('data-delayed-src');
        if (!src || src === 'about:blank') return;
        injectScript(src, loadPickupInventoryWidget);
      });

    if (window.inventoryInfo && window.inventoryInfo.api) {
      loadPickupInventoryWidget();
      return;
    }

    if (document.querySelector('script[src*="locationinventory"]')) {
      loadPickupInventoryWidget();
      return;
    }

    injectScript('https://storefront.locationinventory.info/main.bundle.js', loadPickupInventoryWidget);
  }

  function watchForInventoryMount() {
    if (window.__inventoryMountObserver) return;
    var timer;
    window.__inventoryMountObserver = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        relocateInventoryWidget();
        expandInventoryDetails();
      }, 150);
    });
    window.__inventoryMountObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initProductContentAccordion() {
    var root = document.querySelector('.product__description.rte.quick-add-hidden');
    if (!root || root.dataset.accordionReady === '1') return;

    // Keep the LIVE inventory node reference (do not clone — preserves app mount)
    var liveInventory = root.querySelector('#inventory-info-app') || document.getElementById('inventory-info-app');

    var headings = Array.prototype.slice.call(root.querySelectorAll(':scope > h3'));
    if (!headings.length) headings = Array.prototype.slice.call(root.querySelectorAll('h3'));
    headings = headings.filter(function (heading) {
      return !isPickupHeading(heading.textContent);
    });

    if (!headings.length && !liveInventory) return;

    root.dataset.accordionReady = '1';

    var sections = [];
    var shippingTitle = root.dataset.shippingAccordionTitle || 'Free Shipping And Returns';
    var pickupTitle = root.dataset.pickupAccordionTitle || 'Find In-Store Pickup Options';

    headings.forEach(function (heading) {
      var wrapper = document.createElement('div');
      wrapper.className = 'accordion-content';
      var node = heading.nextElementSibling;
      while (node && node.tagName !== 'H3') {
        var next = node.nextElementSibling;
        if (node.id === 'inventory-info-app' || (node.classList && node.classList.contains('iia-container'))) {
          node = next;
          continue;
        }
        wrapper.appendChild(node);
        node = next;
      }
      sections.push({ heading: heading, content: wrapper });
    });

    var shipHeading = document.createElement('h3');
    shipHeading.textContent = shippingTitle;
    shipHeading.setAttribute('data-shipping-accordion', '1');
    shipHeading.className = 'accordion-header';

    var shipContent = document.createElement('div');
    shipContent.className = 'accordion-content';
    shipContent.innerHTML =
      '<p>Coach ships to all areas of the Kingdom of Saudi Arabia. Delivery times commence from the date of order.<br>' +
      'Please see the table below on shipping times and charges:</p>' +
      '<table class="shipping-table" border="1" cellpadding="8" cellspacing="0" style="border-collapse: collapse; width: 100%;">' +
      '<thead><tr><th>Shipping Options</th><th>Price</th><th>Delivery Time</th></tr></thead>' +
      '<tbody>' +
      '<tr><td>Same Day Delivery (Riyadh)*</td><td>Free delivery over 500 SAR; else, 50 SAR delivery fee.</td><td>1 Business Day</td></tr>' +
      '<tr><td>Standard Delivery</td><td>Free delivery over 500 SAR; else, 50 SAR delivery fee.</td><td>3\u20134 Business Days</td></tr>' +
      '</tbody></table>' +
      '<p>Same Day Delivery is subject to product availability and limited to Riyadh. Orders must be placed by 1:00 PM Saudi time.</p>' +
      '<p>For more on shipping, <a href="/pages/shipping">read here.</a></p>';

    sections.unshift({ heading: shipHeading, content: shipContent });

    var pickupHeading = document.createElement('h3');
    pickupHeading.textContent = pickupTitle;
    pickupHeading.setAttribute('data-pickup-accordion', '1');
    pickupHeading.className = 'accordion-header';

    var pickupContent = document.createElement('div');
    pickupContent.className = 'accordion-content accordion-content--pickup';

    // Detach live inventory before clearing root
    if (liveInventory && liveInventory.parentNode) {
      liveInventory.parentNode.removeChild(liveInventory);
    } else {
      liveInventory = document.createElement('div');
      liveInventory.id = 'inventory-info-app';
      liveInventory.className = 'iia-container product-pickup-inventory';
    }
    liveInventory.id = 'inventory-info-app';
    liveInventory.classList.add('iia-container', 'product-pickup-inventory');
    pickupContent.appendChild(liveInventory);

    var loading = document.createElement('p');
    loading.className = 'pickup-loading-msg';
    loading.style.cssText = 'margin:8px 0 0;font-size:13px;color:#666;';
    loading.textContent = 'Loading store availability\u2026';
    pickupContent.appendChild(loading);

    sections.unshift({ heading: pickupHeading, content: pickupContent, isPickup: true });

    while (root.firstChild) root.removeChild(root.firstChild);

    function setOpen(heading, content, open) {
      if (!heading || !content) return;
      if (open) {
        content.classList.add('is-open');
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
        heading.classList.add('open');
        heading.setAttribute('aria-expanded', 'true');
        if (heading.getAttribute('data-pickup-accordion') === '1') {
          loadInventoryScriptOnce();
          relocateInventoryWidget();
          expandInventoryDetails();
          var msg = content.querySelector('.pickup-loading-msg');
          if (msg && content.querySelector('.iia-list-item, .iia-title-text, .iia-location')) {
            msg.style.display = 'none';
          }
        }
      } else {
        content.classList.remove('is-open');
        content.style.maxHeight = '0px';
        content.style.overflow = 'hidden';
        heading.classList.remove('open');
        heading.setAttribute('aria-expanded', 'false');
      }
    }

    function shouldOpenByDefault(heading) {
      var text = (heading.textContent || '').trim().toLowerCase();
      return (
        text.indexOf('product details') !== -1 ||
        text.indexOf("editor's note") !== -1 ||
        text.indexOf('editor note') !== -1 ||
        text.indexOf('editors note') !== -1 ||
        text.indexOf(String.fromCharCode(0x062a, 0x0641, 0x0627, 0x0635, 0x064a, 0x0644)) !== -1 ||
        text.indexOf(String.fromCharCode(0x0645, 0x0644, 0x0627, 0x062d, 0x0638)) !== -1
      );
    }

    sections.forEach(function (item) {
      var heading = item.heading;
      var content = item.content;
      heading.classList.add('accordion-header');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      content.style.transition = 'max-height 0.3s ease-out';
      setOpen(heading, content, shouldOpenByDefault(heading));
      root.appendChild(heading);
      root.appendChild(content);
    });

    if (!root.dataset.accordionBound) {
      root.dataset.accordionBound = '1';
      root.addEventListener('click', function (event) {
        var heading = event.target.closest('h3.accordion-header');
        if (!heading || !root.contains(heading)) return;
        if (event.target.closest('a, button, input, label.iia-header, .iia-clickable, .iia-list-item')) return;

        var content = heading.nextElementSibling;
        if (!content || !content.classList.contains('accordion-content')) return;

        var isOpen = heading.classList.contains('open');
        if (!isOpen) {
          root.querySelectorAll('h3.accordion-header').forEach(function (other) {
            if (other === heading) return;
            var otherContent = other.nextElementSibling;
            if (otherContent && otherContent.classList.contains('accordion-content')) {
              setOpen(other, otherContent, false);
            }
          });
        }
        setOpen(heading, content, !isOpen);
      });

      root.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var heading = event.target.closest('h3.accordion-header');
        if (!heading || !root.contains(heading)) return;
        event.preventDefault();
        heading.click();
      });
    }

    document.documentElement.classList.add('product-accordions-ready');
    watchForInventoryMount();

    // Start inventory early so opening the accordion shows stores quickly
    setTimeout(loadInventoryScriptOnce, 400);
    setTimeout(relocateInventoryWidget, 1000);
    setTimeout(relocateInventoryWidget, 2500);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        if (window.__locationInventoryRequested) loadPickupInventoryWidget();
      });
    }
  }

  function bootProductContentAccordion() {
    initProductContentAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootProductContentAccordion);
  } else {
    bootProductContentAccordion();
  }

  document.addEventListener('theme:scripts:loaded', bootProductContentAccordion);
})();
